var map = {
	"./checkbox-checked.png": "9O8a",
	"./checkbox-unchecked.png": "P+02",
	"./hotelmeister-logo-autumn.png": "L9vP",
	"./hotelmeister-logo-birthday.png": "Jgxj",
	"./hotelmeister-logo-christmas.png": "tL/E",
	"./hotelmeister-logo-newyear.png": "70Nq",
	"./hotelmeister-logo-spring.png": "XzbU",
	"./hotelmeister-logo-summer.png": "/9H0",
	"./hotelmeister-logo-winter.png": "um3t",
	"./logo.png": "5pHL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xSvB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png nonrecursive \.png$
// module id = xSvB
// module chunks = 0